/**
 * F-180 C14 — tiny debounce primitive.
 *
 * Returns the input value delayed by `delay` ms. Used by SearchPage so
 * typing fires the backend query without spamming a request on every
 * keystroke. Stateless — host owns the live value.
 */
import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
